import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { simulationWebhooksPath } from "./constants";
import type { SimulationWebhooksErrors, SimulationWebhooksQuery, SimulationWebhooksResponse } from "./types";
import { isSimulationWebhooksResult } from "./validators";

export const getSimulationWebhooks = reactQueryFetcherAdapter(
  simulationWebhooksPath,
  createGetFetcherFunctionWithShadowError<SimulationWebhooksErrors>()(
    (
      signal: AbortSignal,
      appGroupId: string,
      query: SimulationWebhooksQuery
    ): Promise<SimulationWebhooksResponse> =>
      fetch(
        `/${appGroupId}/conversational/simulation/webhooks`,
        "GET",
        { workflow_ids: query.workflow_ids.join(",") },
        { signal },
        { propagateFetchRequestError: false }
      )
  ),
  isSimulationWebhooksResult
);
